import { IconSvgProps } from '@/libraries/wpl/foundations/src/icons/types';

export const GroupsIcon = ({ size }: IconSvgProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 49 49"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g
				id="Brand Icons/Groups"
				clipPath="url(#clip0_6876_13409)"
				filter="url(#filter0_d_6876_13409)"
			>
				<g id="Vector">
					<path
						d="M17.4463 31.5C17.4463 27.634 20.5803 24.5 24.4463 24.5C28.3123 24.5 31.4463 27.634 31.4463 31.5V40.5H17.4463V31.5Z"
						fill="#101214"
					/>
					<path
						d="M30.4463 15.5C30.4463 18.8137 27.76 21.5 24.4463 21.5C21.1326 21.5 18.4463 18.8137 18.4463 15.5C18.4463 12.1863 21.1326 9.5 24.4463 9.5C27.76 9.5 30.4463 12.1863 30.4463 15.5Z"
						fill="#101214"
					/>
					<path
						d="M31.2581 21.3824C31.6422 21.4595 32.0395 21.5 32.4463 21.5C35.76 21.5 38.4463 18.8137 38.4463 15.5C38.4463 12.1863 35.76 9.5 32.4463 9.5C32.0395 9.5 31.6422 9.54048 31.2581 9.61764C32.6216 11.1952 33.4463 13.2513 33.4463 15.5C33.4463 17.7487 32.6216 19.8048 31.2581 21.3824Z"
						fill="#101214"
					/>
					<path
						d="M17.6345 9.61764C16.271 11.1952 15.4463 13.2513 15.4463 15.5C15.4463 17.7487 16.271 19.8048 17.6345 21.3824C17.2504 21.4595 16.8531 21.5 16.4463 21.5C13.1326 21.5 10.4463 18.8137 10.4463 15.5C10.4463 12.1863 13.1326 9.5 16.4463 9.5C16.8531 9.5 17.2504 9.54048 17.6345 9.61764Z"
						fill="#101214"
					/>
					<path
						d="M17.3049 24.5C15.5366 26.3037 14.4463 28.7745 14.4463 31.5V40.5H10.4463V29.5C10.4463 26.7386 12.6849 24.5 15.4463 24.5H17.3049Z"
						fill="#101214"
					/>
					<path
						d="M34.4463 40.5V31.5C34.4463 28.7745 33.356 26.3037 31.5877 24.5H33.4463C36.2077 24.5 38.4463 26.7386 38.4463 29.5V40.5H34.4463Z"
						fill="#101214"
					/>
				</g>
			</g>
		</svg>
	);
};
